import { useState, useCallback, useEffect } from 'react';
import { Table, type TableState } from '../components/ui/Table';
import { columns } from '../components/reports/columns';
import { TableData } from '../components/reports/dummyData';
import Breadcrumb from '../components/common/Breadcrumb';
import { Row, Col, Form, Button } from 'react-bootstrap';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Pie, Bar } from 'react-chartjs-2';
import {
  tokenFlowData,
  chartOptions,
  employeeUsageData,
  barOptions,
  departmentData,
} from '../components/reports/chart';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function ReportsPage() {
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [tableState, setTableState] = useState<TableState>({
    sort: { column: null, direction: null },
    filters: {},
  });

  const handleStateChange = (newState: TableState) => {
    setTableState(newState);
  };

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between">
        <div>
          <h2 className="fw-bold">Reports</h2>
        </div>
        <div className="d-flex justify-content-center">
          <div className="d-flex gap-2 align-items-center">
            <Button variant="outline-secondary border-2 rounded-2 text-dark bg-white fw-bold">
              Download Report
            </Button>
          </div>
        </div>
      </div>
      <div className="bg-white p-2 rounded-3">
        <div className="d-flex flex-wrap align-items-center p-2">
          <p className="mb-0 fw-bold h4">Token Analytics Report</p>
          <div className="flex-fill">
            <Row className="ml-auto justify-content-lg-end">
              <Col xs={12} sm={4} lg={2}>
                <Form.Select>
                  <option value="">Last Week</option>
                  <option value="">Last Month</option>
                  <option value="">Last Year</option>
                </Form.Select>
              </Col>
              <Col xs={12} sm={4} lg={2}>
                <Form.Select>
                  <option value="">Employee</option>
                  <option value="">Contractor</option>
                </Form.Select>
              </Col>
              <Col xs={12} sm={4} lg={2}>
                <Form.Select>
                  <option value="">Transaction Type</option>
                </Form.Select>
              </Col>
            </Row>
          </div>
        </div>
        <Row className="p-2">
          <Col xs={12} md={6} lg={4}>
            <div className="border rounded-3 p-3">
              <div>
                <Pie data={tokenFlowData} options={chartOptions} />
              </div>
              <div className="mt-4 text-center fw-semibold text-gray-600">
                Token inflow vs outflow
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="border rounded-3 p-3">
              <div>
                <Bar data={employeeUsageData} options={barOptions} />
              </div>
              <div className="mt-4 text-center fw-semibold text-gray-600">
                Employee Token Usage Breakdown
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="border rounded-3 p-3">
              <div>
                <Pie data={departmentData} options={chartOptions} />
              </div>
              <div className="mt-4 text-center fw-semibold text-gray-600">
                Departmental Token Transferred
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Table
        columns={columns}
        data={TableData.data}
        loading={loading}
        hasMore={hasMore}
        onLoadMore={() => {}}
        onStateChange={handleStateChange}
        initialState={tableState}
      />
    </>
  );
}
